declare namespace $ {

	type $mol_view__sub_shm_ba_posts_1 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['title_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_posts_page_button__title_shm_ba_posts_2 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_title'] >
		,
		ReturnType< $shm_ba_posts_page_button['title'] >
	>
	type $shm_ba_posts_page_button__current_shm_ba_posts_3 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_current'] >
		,
		ReturnType< $shm_ba_posts_page_button['current'] >
	>
	type $shm_ba_posts_page_button__click_shm_ba_posts_4 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_pick'] >
		,
		ReturnType< $shm_ba_posts_page_button['click'] >
	>
	type $mol_view__sub_shm_ba_posts_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_posts_6 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_posts_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__Filter_shm_ba_posts_8 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__value_shm_ba_posts_9 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_ba_posts_10 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_ba_posts_11 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_ba_posts_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_posts_13 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['Page_size'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_ba_posts_14 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_tools'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_posts_page_button__title_shm_ba_posts_15 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_title'] >
		,
		ReturnType< $shm_ba_posts_page_button['title'] >
	>
	type $shm_ba_posts_page_button__current_shm_ba_posts_16 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_current'] >
		,
		ReturnType< $shm_ba_posts_page_button['current'] >
	>
	type $shm_ba_posts_page_button__click_shm_ba_posts_17 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_pick'] >
		,
		ReturnType< $shm_ba_posts_page_button['click'] >
	>
	type $mol_view__sub_shm_ba_posts_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_posts_19 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_number_rows_bottom'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_posts_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__Filter_shm_ba_posts_21 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__value_shm_ba_posts_22 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_ba_posts_23 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_ba_posts_24 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_size_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_ba_posts_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_ba_posts_26 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['Page_size_bottom'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_ba_posts_27 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['page_tools_bottom'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_posts_28 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['more_sort_buttons'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_ba_posts_sort_button__title_shm_ba_posts_29 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['sort_title'] >
		,
		ReturnType< $shm_ba_posts_sort_button['title'] >
	>
	type $shm_ba_posts_sort_button__current_shm_ba_posts_30 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['sort_current'] >
		,
		ReturnType< $shm_ba_posts_sort_button['current'] >
	>
	type $shm_ba_posts_sort_button__click_shm_ba_posts_31 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['sort_pick'] >
		,
		ReturnType< $shm_ba_posts_sort_button['click'] >
	>
	type $mol_pick__trigger_content_shm_ba_posts_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_ba_posts_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $shm_ba_post_card__post_row_shm_ba_posts_34 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['post_row'] >
		,
		ReturnType< $shm_ba_post_card['post_row'] >
	>
	type $shm_ba_post_card__table_shm_ba_posts_35 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['table'] >
		,
		ReturnType< $shm_ba_post_card['table'] >
	>
	type $shm_ba_post_card__highlight_shm_ba_posts_36 = $mol_type_enforce<
		ReturnType< $shm_ba_posts['highlight'] >
		,
		ReturnType< $shm_ba_post_card['highlight'] >
	>
	export class $shm_ba_posts extends $mol_view {
		title_content( ): readonly(any)[]
		Title( ): $mol_view
		page_number_title( id: any): string
		page_number_current( id: any): boolean
		page_pick( id: any, next?: any ): any
		Page_number( id: any): $shm_ba_posts_page_button
		Page_gap( id: any): $mol_view
		page_number_rows( ): readonly(any)[]
		Page_numbers( ): $mol_view
		page_info( ): string
		Page_info( ): $mol_view
		page_size( next?: string ): string
		page_size_options( ): readonly(any)[]
		page_size_dict( ): Record<string, any>
		Page_size( ): $mol_select
		Page_size_label( ): $mol_labeler
		page_tools( ): readonly(any)[]
		Page_tools( ): $mol_view
		Title_spacer( ): $mol_view
		Page_number_bottom( id: any): $shm_ba_posts_page_button
		Page_gap_bottom( id: any): $mol_view
		page_number_rows_bottom( ): readonly(any)[]
		Page_numbers_bottom( ): $mol_view
		Page_info_bottom( ): $mol_view
		Page_size_bottom( ): $mol_select
		Page_size_label_bottom( ): $mol_labeler
		page_tools_bottom( ): readonly(any)[]
		Page_tools_bottom( ): $mol_view
		post_rows( ): readonly(any)[]
		sort_title( id: any): string
		sort_current( id: any): boolean
		sort_pick( id: any, next?: any ): any
		more_sort_buttons( ): readonly(any)[]
		More_sort_list( ): $mol_list
		post_row( id: any): any
		table( ): any
		table_count( ): number
		highlight( ): string
		sort( next?: string ): string
		sort_order( next?: string ): string
		page( next?: number ): number
		sub( ): ReturnType< $shm_ba_posts['post_rows'] >
		Sort_button( id: any): $shm_ba_posts_sort_button
		More_sort( ): $mol_pick
		Post( id: any): $shm_ba_post_card
	}
	
	export class $shm_ba_posts_sort_button extends $mol_button_minor {
		click( next?: any ): any
		current( ): boolean
		attr( ): ({ 
			'shm_ba_posts_sort_current': ReturnType< $shm_ba_posts_sort_button['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		sub( ): readonly(any)[]
		event( ): ({ 
			click( next?: ReturnType< $shm_ba_posts_sort_button['click'] > ): ReturnType< $shm_ba_posts_sort_button['click'] >,
		})  & ReturnType< $mol_button_minor['event'] >
	}
	
	export class $shm_ba_posts_page_button extends $mol_button_minor {
		click( next?: any ): any
		current( ): boolean
		attr( ): ({ 
			'shm_ba_posts_page_current': ReturnType< $shm_ba_posts_page_button['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		sub( ): readonly(any)[]
		event( ): ({ 
			click( next?: ReturnType< $shm_ba_posts_page_button['click'] > ): ReturnType< $shm_ba_posts_page_button['click'] >,
		})  & ReturnType< $mol_button_minor['event'] >
	}
	
}

//# sourceMappingURL=posts.view.tree.d.ts.map